<template>
  <div class="sys-tissues">
      <ToolBar
      :searchArr="fields"
      :showChildren="showChildren"
      :showChildrenText="showChildrenText"
      @filter="filterFields"
      @search="search"
      @add="add"
      @expand="expand"
      placeholder="输入组织名称搜索"
      ></ToolBar>
      <div class="table-content">
          <Table
            ref="table"
            :isPagination="isPagination"
            :expandedRowKeys.sync="expandedRowKeys"
            :options="fields"
            :tableValue="tableValue"
            :customSlotOpt="slotOpt"
            @change="initTableValue"
            @actionClick="handlerActionClick"
            :scroll="{ x: 1300, y: `calc(100vh - ${234 + 'px'})` }"
        ></Table>
        <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
        <Modal :treeData="tableValue" :row="row" :isEdit="isEdit" :visible="visible" @ok="handleClickOk"></Modal>
      </div>
  </div>
</template>

<script>
import {delDept, depTreeSelectCount} from '@/api/back.js'
import { fields, slotOpt} from './config'
import mixinsBackStack from '@/views/Back/mixins'
import ToolBar from '../../components/toolBar/index.vue'
import Table from '@/views/Back/components/table/index.vue'
import AModal from '@/views/Back/components/AModal'
import Modal from './modal.vue'
export default {
  mixins: [mixinsBackStack],
  components: {
    ToolBar,
    Table,
    AModal,
    Modal
  },
  data() {
      return {
          row: {},
          isEdit: false,
          visible: false,
          showAdd: true,
          showExp: false,
          isPagination: false,
          showChildren: true,
          showChildrenText: true,
          fields,
          slotOpt,
          tableValue: [],
          serchText: '',
          expandedRowKeys: []
      }
  },
  watch: {
    expandedRowKeys: {
      handler() {
        if(this.expandedRowKeys.length === this.expandedRow.length) {
           this.showChildrenText = false
        } else {
          this.showChildrenText = true
        }
      }
    }
  },
  mounted() {
    this.initTableValue()
  },
  methods: {
      handleClickOk() {
          this.visible = false
          this.id = null
          this.isEdit = false
          this.initTableValue()
      },
      async initTableValue(query = {}) {
        try {
          this.loadingTable(true) // 开启表格的加载动画
          const { data } = await depTreeSelectCount(query) // 请求表格数据接口
          const row = this.handlerDateFormatRecursion(data) // 处理时间格式
          //this.handlerResultMappings(rows) // 处理数据的映射关系
          this.tableValue = row
          //this.customOtherOpt.pagination.total = total
          this.initSelectedRowIds() // 清空勾选的选项
        } catch (error) {
          this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
        } finally {
          this.loadingTable(false)
        }
      },
      //处理子组件返回的参数
      search(v) {
        v ? this.initTableValue({deptName: v}) : this.initTableValue()
      },
      //点击折叠或者展开
      expand() {
        if(this.expandedRowKeys.length === this.expandedRow.length) {
          this.expandedRowKeys = []
          this.showChildrenText = true
        } else {
          this.expandedRowKeys = [...this.expandedRow]
          this.showChildrenText = false
        }
      },
      add(row) {
        console.log('row', row)
        this.row = row || {}
        this.visible = true
      },
      edit(row) {
        this.isEdit = true
        this.visible = true
        this.row = row
      },
      // 单独删除
      singleDelete(row) {
        this.customModalOpt.contentTips = '是否确定删除该内容'
        this.beforeShowModal(true, {
            source: 'dealDeleteApi',
            params: { ids: row.id }
        })
      },
      // 调用删除接口
      async dealDeleteApi(params) {
        const { ids } = params
        console.log(ids)
        try {
            const { msg, code } = await delDept(ids)
            this.initTableValue()
            this.$apiStatusHandler(code, msg)
        } catch (error) {
            this.$apiStatusHandler(99, error.msg)
        }
      },
      filterFields({v, i}) {
      this.$set(this.fields[i], "isShow", v)  
    },
  }
}
</script>

<style>
</style>